import React from "react";

import { LoadingButton } from "@mui/lab";
import { Box, Grid, TextField } from "@mui/material";

import GenericDialog from "components/shared/generic-dialog";

export interface NewAttributeFormState {
  name: string;
  description: string;
}

interface AddAttributeFormProps {
  isOpen: boolean;
  handleClose: () => void;
  newAttributeFormState: {
    name: string;
    description: string;
  };
  setNewAttributeFormState: (newState: NewAttributeFormState) => void;
  handleSubmit: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

const AddExtractAttributeForm = ({
  isOpen,
  handleClose,
  newAttributeFormState,
  setNewAttributeFormState,
  handleSubmit,
  isLoading,
  isDisabled,
}: AddAttributeFormProps) => {
  return (
    <GenericDialog
      title="Add Attribute"
      width="md"
      hasXCloseBtn
      open={isOpen}
      handleDialogClose={handleClose}
      data-testid="add-attribute-dialog"
    >
      <Grid xs={12} item>
        <form noValidate autoComplete="off">
          <Box
            sx={{ height: "70vh", width: "100%" }}
            display="flex"
            flexDirection="column"
            gap={4}
            marginTop={4}
          >
            <TextField
              required
              label="Name"
              inputProps={{
                "data-testid": "add-attribute-name-field",
              }}
              value={newAttributeFormState.name}
              onChange={(event) =>
                setNewAttributeFormState({
                  ...newAttributeFormState,
                  name: event.target.value,
                })
              }
            />
            <TextField
              required
              label="Description"
              inputProps={{
                "data-testid": "add-attribute-description-field",
              }}
              value={newAttributeFormState.description}
              onChange={(event) =>
                setNewAttributeFormState({
                  ...newAttributeFormState,
                  description: event.target.value,
                })
              }
            />
          </Box>
          <LoadingButton
            color="primary"
            onClick={handleSubmit}
            loading={isLoading}
            disabled={isDisabled}
            loadingPosition="center"
            variant="contained"
            data-testid="add-attribute-btn"
          >
            Add Attribute
          </LoadingButton>
        </form>
      </Grid>
    </GenericDialog>
  );
};

export default AddExtractAttributeForm;
